
import React from 'react'
import Icon from './Icon'

const FaLock = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m14.1 17.1h11.5v-4.2q0-2.4-1.7-4.1t-4-1.7-4.1 1.7-1.7 4.1v4.2z m18.6 2.2v12.8q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.8 0-1.5-0.6t-0.6-1.6v-12.8q0-0.9 0.6-1.5t1.5-0.7h0.8v-4.2q0-4.1 2.9-7.1t7.1-2.9 7 2.9 3 7.1v4.2h0.7q0.9 0 1.5 0.7t0.6 1.5z"/></g>
    </Icon>
)

export default FaLock



// WEBPACK FOOTER //
// ./src/components/Icon/lock.js